import { createAction } from "@reduxjs/toolkit";

export const visibilityChangeReconnection = {
  reconnectionEstablished: createAction(
    "lwc/visibilityChange/reconnectionEstablished"
  ),
};
